import { Author } from 'types';

export default (authors: Author[]): string => {
  return authors.reduce((concattedList, author, index) => {
    concattedList += `${author.firstName} ${author.lastName}`;
    if (index < authors.length - 1) concattedList += ', ';
    return concattedList;
  }, '');
};
